/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GenerateTokenReq, GenerateTokenResp, HTTPValidationError, SharedPageResponse } from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSharedPageUrl = (sharedPageId: string) => {
  return `/api/v1/share/${sharedPageId}`;
};

/**
 * Get a shared page by id.
 * @summary Get Shared Page
 */
export const getSharedPage = async (
  sharedPageId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<SharedPageResponse> => {
  return customFetch<SharedPageResponse>(getGetSharedPageUrl(sharedPageId), {
    ...options,
    method: 'GET',
  });
};

export const getGetSharedPageQueryKey = (sharedPageId: string) => {
  return [`/api/v1/share/${sharedPageId}`] as const;
};

export const getGetSharedPageQueryOptions = <
  TData = Awaited<ReturnType<typeof getSharedPage>>,
  TError = HTTPValidationError,
>(
  sharedPageId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSharedPage>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSharedPageQueryKey(sharedPageId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedPage>>> = ({ signal }) =>
    getSharedPage(sharedPageId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: sharedPageId !== null && sharedPageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSharedPage>>, TError, TData> & { queryKey: QueryKey };
};

export type GetSharedPageQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedPage>>>;
export type GetSharedPageQueryError = HTTPValidationError;

/**
 * @summary Get Shared Page
 */

export function useGetSharedPage<TData = Awaited<ReturnType<typeof getSharedPage>>, TError = HTTPValidationError>(
  sharedPageId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSharedPage>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSharedPageQueryOptions(sharedPageId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGenerateTokenUrl = () => {
  return `/api/v1/share/generate-token`;
};

/**
 * Generate a token to share a report, feedback or user intelligence externally.
 * @summary Generate Token
 */
export const generateToken = async (
  generateTokenReq: GenerateTokenReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<GenerateTokenResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GenerateTokenResp>(getGenerateTokenUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateTokenReq),
  });
};

export const getGenerateTokenMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateToken>>,
    TError,
    GenerateTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof generateToken>>, TError, GenerateTokenMutationVariables, TContext> => {
  const mutationKey = ['generateToken'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateToken>>, GenerateTokenMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return generateToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof generateToken>>>;
export type GenerateTokenMutationBody = GenerateTokenReq;
export type GenerateTokenMutationError = HTTPValidationError;
export type GenerateTokenMutationVariables = { data: GenerateTokenReq };

/**
 * @summary Generate Token
 */
export const useGenerateToken = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateToken>>,
    TError,
    GenerateTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof generateToken>>, TError, GenerateTokenMutationVariables, TContext> => {
  return useMutation(getGenerateTokenMutationOptions(options));
};
